export enum FORM_STAGE {
  CREATE_PROFILE = 'CREATE_PROFILE',
  SELECT_ORG = 'SELECT_ORG',
}
export const FORM_HEADER: { [key in FORM_STAGE]: string } = {
  CREATE_PROFILE: 'Create Your Prescriber Profile',
  SELECT_ORG: 'Link Your Organisation',
}

export enum PrescriberTitle {
  Dr = 'Dr',
  Mr = 'Mr',
  Mrs = 'Mrs',
  Miss = 'Miss',
  Ms = 'Ms',
}
